import {
  UnknownFirestoreDoc,
  useFirestoreDoc,
} from "@p0security/frontend-core/react";

import { JIRA_TRACKER_KEYS, JiraTrackerDoc, JiraTrackerKey } from "../trackers";

/** Reads the tenant's Jira tracker doc, whichever Jira tracker wrote it.
 *
 * `key` names the installed tracker, or else the first tracker that has a doc
 * (an install in progress), so that callers can link to that tracker's page.
 *
 * @param collection The integrations collection path, `integrations` with
 *   `tenantAware` or `o/<tenant>/integrations` without
 */
export const useJiraTrackerDoc = (
  collection: string,
  options?: Parameters<typeof useFirestoreDoc>[1]
) => {
  const docs: Record<JiraTrackerKey, UnknownFirestoreDoc<JiraTrackerDoc>> = {
    jira: useFirestoreDoc<JiraTrackerDoc>(`${collection}/jira`, options),
    "jira-tracker": useFirestoreDoc<JiraTrackerDoc>(
      `${collection}/jira-tracker`,
      options
    ),
  };
  const key =
    JIRA_TRACKER_KEYS.find((k) => docs[k].doc?.data.state === "installed") ??
    JIRA_TRACKER_KEYS.find((k) => docs[k].doc);
  return {
    key,
    doc: key ? docs[key].doc : undefined,
    loading: JIRA_TRACKER_KEYS.some((k) => docs[k].loading),
  };
};
